import React, {useState} from 'react';
import * as S from './MultiSelection.styles';
import Icon from '../IconsSelector'

interface IMultiSelection {
  t?: string;
  img_url?: string;
  checked?: boolean;
  onToggle?: Function;
  oc?: string;
  fc: string;
}

const MultiSelection: React.FC<IMultiSelection> = ({ t, icon, checked = false, onToggle = () => {}, oc = '', fc = '', isSeo=false }) => {
  const updateToggle = () => {
    onToggle({type: 'msf', oc, fc, is_applied: !checked});
  }
  return (
    <>
      <S.Checkbox onClick={() => updateToggle()}>
        {isSeo ? <input type="checkbox" id={''} />  : <input type="checkbox" id={''} checked={checked} /> }
        <label
          className={"labelWithIcon"}
          htmlFor={t}
        >
          {icon ?
            <img
              src={icon}
              width="54px"
              height="20px"
            />
            : null}
          <span
            dangerouslySetInnerHTML={{
            __html: t,
          }}
          ></span>
        </label>
      </S.Checkbox>
    </>
  );
}

export default MultiSelection;